import React from 'react';
import SuggestionsCard from './SuggestionsCard';
import EffectifCard from './EffectifCard';
import TrialPeriodCard from './TrialPeriodCard';
import VisaExpirationCard from './VisaExpirationCard';
import TodaysStats from '../../types/api/TodaysStats';
import Employee from '../../types/api/Employee';

interface Props {
  dashboardInfos?: TodaysStats;
  freeTodayNoon?: string[];
  freeTodayEvening?: string[];
  employees: Employee[];
}

const TabRH: React.FC<Props> = ({ dashboardInfos, freeTodayNoon, freeTodayEvening, employees }) => {
  // Prefer explicit props if provided, otherwise fallback to values inside dashboardInfos
  const freeNoon = freeTodayNoon ?? dashboardInfos?.freeTodayNoon ?? [];
  const freeEvening = freeTodayEvening ?? dashboardInfos?.freeTodayEvening ?? [];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          <h2 className="text-2xl font-semibold mb-3  ">Suggestions de remplacements</h2>
          <SuggestionsCard noonSuggestions={freeNoon} eveningSuggestions={freeEvening} />
          <div className="space-y-4 ">
          <div>
            <h2 className="text-2xl font-semibold mb-3">Période d'essai</h2>
            <TrialPeriodCard employees={employees} />
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-3">Expiration des visas</h2>
            <VisaExpirationCard employees={employees} />
          </div>
        </div>
        </div>
        
     <div>
          <h2 className="text-2xl font-semibold mb-3">Effectifs prévus aujourd'hui</h2>
          <EffectifCard 
            cuisineMidi={dashboardInfos?.todayNoonNeeds?.kitchen ?? 0} 
            salleMidi={dashboardInfos?.todayNoonNeeds?.service ?? 0} 
            cuisineSoir={dashboardInfos?.todayEveningNeeds?.kitchen ?? 0} 
            salleSoir={dashboardInfos?.todayEveningNeeds?.service ?? 0}
            cuisineMidiScheduled={dashboardInfos?.todayNoonScheduled?.kitchen}
            salleMidiScheduled={dashboardInfos?.todayNoonScheduled?.service}
            cuisineSoirScheduled={dashboardInfos?.todayEveningScheduled?.kitchen}
            salleSoirScheduled={dashboardInfos?.todayEveningScheduled?.service}
          />
        </div>

 
      </div>
    
    </div>
  );
};

export default TabRH;